import React from 'react';
import Progress from './Progress';
import Logoloder from '../../assets/images/loader/Logoloder';

const Loader = () => {
  return (
    <React.Fragment>
      {/* <Progress isAnimating /> */}
      <Logoloder />
    </React.Fragment>
  );
};

export default Loader;
